/** Does the current route include `start` */
export function isDirectToPayRoute(): boolean {
  const directToPayPath = [
    '/start',
    // Some other routes also redirect to /start but are not guaranteed to have already been
    // redirected at the time this function is called.
    '/free-trial',
    '/pay',
    '/email-pay',
  ];

  return directToPayPath.some((dtpPath) => window.location.pathname.includes(dtpPath));
}

export function isLocalhost(): boolean {
  return window.location.hostname === 'localhost';
}
